<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="exportQuotaCustomer"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#F9FAFC" title="批量下载" fontSize="14px" @btnclick="DownloadAll"
				:src="require('@/assets/channel/all-download.png')">
			</Commonbtn>
		</div>
		<div class="Table">
			<Commontable ref="refTableCenter" @onRowClick="onRowClick" width="1000px" colnum=7 :tableData="tableData"
				:headerData="headerData" height="100%" @handleSelectionChange="(e)=>selectValues = e">
			</Commontable>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import FromComm from '../../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../../components/common-btn.vue'
	import Pagination from '../../../../../../../components/pagination.vue'
	import CommonbtnUpLoad from './../../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../../components/common-table.vue'
	import FromArr from '../FormData/FromArrHistory'
	import headerData from '../TableData/headerData3'
	import utils from "../../../../../../../common/utils";
	import {
		InventoryClassList,
	} from '@/api/home'
	import {
		CustomerQuotaHistoryList,
		ExportCustomerQuotaHistory,
		GeneratePdfCustomerQuotaHistory
	} from '@/api/newsapi'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Pagination,
			CommonbtnUpLoad,
			Commontable
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				FromArr: [],
				tableCurr: null,
				tableData: [],
				headerData: [],
				selectValues: [],
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.inventoryClassList();
			this.getData();
		},
		methods: {
			async getData() {
				this.query.cusName = this.FromArr[0].modelvalue;
				this.query.invClass = this.FromArr[1].modelvalue;
				this.query.year = this.FromArr[2].modelvalue;

				let {
					code,
					data
				} = await CustomerQuotaHistoryList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data.map(item => {
						item.ReviseTime = item.ReviseTime ? item.ReviseTime.substring(0, 10) : '';
						return item;
					});
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[1].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArr[1].options.push(obj)
					})
					let date = new Date()
					let yearArr = [
						date.getFullYear() - 1,
						date.getFullYear(),
						date.getFullYear() + 1
					]
					yearArr.map((item, index) => {
						let obj = {
							key: item,
							value: item
						}
						this.FromArr[2].options.push(obj)
					})
				} else {
					this.$message.error('公司加载失败')
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
					return;
				})
				this.getData();
			},
			onRowClick(val) {
				this.tableCurr = val.ID;
			},
			// 导出
			async exportQuotaCustomer() {
				this.query.cusName = this.FromArr[0].modelvalue;
				this.query.invClass = this.FromArr[1].modelvalue;
				this.query.year = this.FromArr[2].modelvalue;

				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportCustomerQuotaHistory(this.query)
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `历史盖章文件${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			async DownloadAll() {
				if (this.selectValues.length > 0) {
					let IDs = [];
					this.selectValues.forEach((item, index) => {
						IDs.push(item.ID);
					})
					const loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let res = await GeneratePdfCustomerQuotaHistory({
						iDs: IDs
					})
					if (res) {
						let date = new Date();
						let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`;
						utils.downloadFile(res, `历史盖章文件批量下载-${str}`, this.selectValues.length > 1 ? 'rar' : 'pdf');
					} else {
						this.$message.warning(`导出失败`);
					}
					loading.close();
				} else {
					this.$message.warning('请选择需要下载的数据')
				}
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			}
		}
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 113px;
		margin: 16px 0px 8px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: 0px;
		}
	}

	.BottomTable {
		margin-bottom: 14px;
	}

	.custom-table {
		cursor: pointer;
		user-select: none;
		margin-bottom: 16px;
		box-sizing: border-box;

		.table-header {
			height: 40px;
			background: #00266D;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0px 16px;

			span {
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #FFFFFF;
			}
		}

		.red {
			background: #E71D43;
		}

		.table-title {
			display: flex;

			.title-item {
				flex: 1;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 500;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-bottom: 1px solid #EEEEEE;
				border-right: 1px solid #EEEEEE;
				box-sizing: border-box;
			}

			.title-item:last-child {
				border-right: 0px;
			}
		}

		.table-value {
			display: flex;

			.value-item {
				flex: 1;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 500;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-bottom: 1px solid #EEEEEE;
				border-right: 1px solid #EEEEEE;
				box-sizing: border-box;
			}

			.value-item:last-child {
				border-right: 0px;
			}
		}
	}

	.select-table {
		border: 1px solid #00266D;
	}



	.dialog-form {
		.dialog-info {
			display: flex;
			align-items: stretch;
			flex-wrap: wrap;
			justify-content: space-between;
			height: 100px;

			.info-item {
				width: 33.33%;
				display: flex;
				align-items: center;

				.info-key {
					font-size: 14px;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #666666;
				}

				.info-val {
					font-size: 14px;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;

					.inputval {
						width: 60px;
						height: 32px;
						line-height: 32px;
						border-radius: 2px;
						border: 1px solid #E5E5E5;
						padding: 0px 16px;
						margin-right: 8px;
					}

					.btnselect {
						width: 64px;
						height: 32px;
						border: 1px solid #e6e6e6;
						border-radius: 2px;
						text-align: center;
						// line-height: 32px;
						color: #fff;
						background-color: #e71d43;
						display: inline-block;
						margin-left: 10px;
						cursor: pointer;
						opacity: 1;
					}

					.btnselect:hover {
						background-color: #e03f5d;
					}

					.btnselect:active {
						background-color: #c01837;
					}
				}
			}
		}

		.dialog-card {
			padding: 16px;
			border: 1px solid #EEEEEE;
			margin-bottom: 16px;

			.card-title {
				font-size: 14px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
				position: relative;
			}

			.card-title::before {
				content: " ";
				position: absolute;
				left: -16px;
				top: 2px;
				border-left: 4px solid #E71D43;
				height: 16px;
			}

			.card-info {
				display: flex;
				align-items: stretch;
				flex-wrap: wrap;
				justify-content: space-between;
				height: 60px;

				.info-item {
					width: 33.33%;
					display: flex;
					align-items: center;

					.info-key {
						font-size: 14px;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #666666;
					}

					.info-val {

						.inputval {
							width: 160px;
							height: 32px;
							line-height: 32px;
							border-radius: 2px;
							border: 1px solid #E5E5E5;
							padding: 0px 16px;


							/deep/.el-input__inner {
								border: none !important;
								height: 32px;
								line-height: 32px;
								padding: 0px;
							}

							/deep/.el-input__prefix {
								display: none;
							}

							/deep/.el-input__suffix {
								display: none;
							}
						}
					}
				}
			}
		}
	}
</style>